<template>
    <div class="main">
        <div class="main_box">
            <!--企业头部信息-->
            <div class="main_header">
                <div class="header_name">{{companyData.companyName}}</div>
                <div class="header_box">
                    <div class="locationBage">{{companyData.regionCode}}</div>
                    <div class="industryBage ">{{companyData.industryCategory}}</div>
                </div>
                <div class="header_time">
                    <span class="time_left">营业时间：</span>
                    <span class="time_right">{{workerTime}} - {{workerTimeLate}}</span>
                </div>
                <div class="header_time">
                    <span class="time_left">详细地址：</span>
                    <span class="time_right">{{companyData.address}}</span>
                </div>
            </div>
            <!--诚信指数-->
            <div class="main_trust line_top" v-if="companyData.enterpriseStatus===0 || companyData.enterpriseStatus===1">
                <div class="trust_title">
                    <div class="title_left">诚信指数</div>
                    <div class="title_right">{{companyData.score|toFix()}}</div>
                </div>
                <div class="trust_count">
                    <div class="count_box">
                        <span class="count_box_left">规范指数：</span>
                        <span class="count_box_right">{{companyData.standardScore|toFix()}}</span>
                    </div>
                    <div class="count_box">
                        <span class="count_box_left">体验指数：</span>
                        <span class="count_box_right">{{companyData.experienceScore|toFix()}}</span>
                    </div>
                    <div class="count_box">
                        <span class="count_box_left">品质指数：</span>
                        <span class="count_box_right">{{companyData.qualityScore|toFix()}}</span>
                    </div>
                </div>
                <div class="trust_type" v-if="companyData.enterpriseStatus===1">
                    <div class="trust_type_line">
                        <span>当前状态：</span>
                        <span class="line_right">{{companyData.enterpriseStatusName}}</span>
                    </div>
                    <div class="trust_type_line">
                        <span>入榜时间：</span>
                        <span>{{scoreTime}}</span>
                    </div>
                    <div class="trust_type_line">
                        <span>累计入榜：</span>
                        <span>{{duration}}</span>
                    </div>
                </div>
            </div>
            <!--纳入评分-->
            <div class="main_score line_top" v-if="companyData.enterpriseStatus===2 || companyData.enterpriseStatus===3">
                <div class="score_title">
                    <div class="title_left">纳入评分</div>
                    <div class="title_right">{{companyData.enteredInfo.score|toFix()}}</div>
                </div>
                <div class="score_count">
                    <div class="count_box">
                        <span class="count_box_left">规范指数：</span>
                        <span class="count_box_right">{{companyData.enteredInfo.standardScore|toFix()}}</span>
                    </div>
                    <div class="count_box">
                        <span class="count_box_left">品质指数：</span>
                        <span class="count_box_right">{{companyData.enteredInfo.qualityScore|toFix()}}</span>
                    </div>
                    <div class="count_box">
                        <span class="count_box_left">体验指数：</span>
                        <span class="count_box_right">{{companyData.enteredInfo.experienceScore|toFix()}}</span>
                    </div>
                </div>
                <div class="score_type">
                    <div class="score_type_line">
                        <span>当前状态：</span>
                        <span class="line_right">{{companyData.enterpriseStatusName}}</span>
                    </div>
                    <div class="score_type_line">
                        <span>纳入时间：</span>
                        <span>{{scoreTime}}</span>
                    </div>
                    <div class="score_type_line" v-if="companyData.enterpriseStatus===2">
                        <span>累计纳入时间：</span>
                        <span>{{duration}}</span>
                    </div>
                    <div class="score_type_line" v-if="companyData.enterpriseStatus===3">
                        <span>已进入：</span>
                        <span>{{duration}}</span>
                    </div>
                </div>
            </div>
            <!--当前评分-->
            <div class="main_rating line_top" v-if="companyData.enterpriseStatus===2 || companyData.enterpriseStatus===3">
                <div class="rating_title">
                    <div class="title_left">当前评分</div>
                    <div class="title_right">{{companyData.score}}</div>
                </div>
                <div class="rating_count">
                    <div class="count_box">
                        <span class="count_box_left">规范指数：</span>
                        <span class="count_box_right">{{companyData.standardScore|toFix()}}</span>
                    </div>
                    <div class="count_box">
                        <span class="count_box_left">品质指数：</span>
                        <span class="count_box_right">{{companyData.qualityScore|toFix()}}</span>
                    </div>
                    <div class="count_box">
                        <span class="count_box_left">体验指数：</span>
                        <span class="count_box_right">{{companyData.experienceScore|toFix()}}</span>
                    </div>
                </div>
            </div>
            <!--企业信息-->
            <div class="main_comInfo line_top">
                <div class="comInfo_title">企业信息</div>
                <div class="comInfo_box">
                    <span class="comInfo_box_left">门店名称：</span>
                    <span class="comInfo_box_right">{{companyData.name}}</span>
                </div>
                <div class="comInfo_box">
                    <span class="comInfo_box_left">法人代表：</span>
                    <span class="comInfo_box_right">{{companyData.lawName}}</span>
                </div>
                <div class="comInfo_box">
                    <span class="comInfo_box_left">统一社会信用代码：</span>
                    <span class="comInfo_box_right">{{companyData.creditCode}}</span>
                </div>
                <div class="comInfo_box">
                    <span class="comInfo_box_left">经营许可证编号：</span>
                    <span class="comInfo_box_right">{{companyData.businessLicense}}</span>
                </div>
                <div class="comInfo_box">
                    <span class="comInfo_box_left">注册信息：</span>
                    <span class="comInfo_box_right">{{companyData.address}}</span>
                </div>
                <div class="comInfo_box">
                    <span class="comInfo_box_left">主营业务：</span>
                    <span class="comInfo_box_right">{{companyData.businessScope}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import api from '../../../../service/modules/integrity';
    export default {
        data () {
            return {
                companyData: {},
                scoreTime: '',
                enterpriseId: '',
                duration: '',
                workerTimeLate: '', // 营业时间的结束时间
                workerTime: ''// 营业时间的开始时间
            }
        },
        created () {
            this.enterpriseId = this.$route.query.enterpriseId;
            this.getEnterpriseDetail();
        },
        methods: {
            getEnterpriseDetail () {
                api
                    .scarnDetails({ enterpriseId: this.enterpriseId })
                    .then(res => {
                        if (res.ret === 0) {
                            this.companyData = res.data;
                            if (this.companyData.businessDateBegin === null && this.companyData.businessDateEnd === null) {
                                this.workerTime = '';
                                this.workerTimeLate = '';
                            } else {
                                this.workerTime = moment(this.companyData.businessDateBegin).format('YYYY.MM.DD');
                                this.workerTimeLate = moment(this.companyData.businessDateEnd).format('YYYY.MM.DD');
                            }
                            if (this.companyData.enteredInfo !== undefined) {
                                console.log('<<<<<<<<<', this.companyData.enteredInfo)
                                this.scoreTime = moment(this.companyData.enteredInfo.enteredTime).format('YYYY-MM-DD HH:MM:SS');
                                this.duration = this.companyData.enteredInfo.duration;
                                console.log('<<<<<<<<<<<<<<<<<<<<<<<<<<<2222', this.duration)
                            }
                        }
                    });
            }
        },
        filters: {
            toFix (str) {
                if (str) {
                    return Number(str.toFixed(2))
                } else {
                    return str;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.main {
    background: #FBFBFB;
    padding: 16px 12px 23px;
    height: 100vh;
    .main_box {
        width:351px;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        .main_header {
            width: 100%;
            height: 100%;
            padding: 20px 16px 19px;
            .header_name {
                font-size:14px;
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:rgba(51,51,51,1);
                line-height:16px;
                margin-bottom: 8px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .header_box::after {
                content: "";
                display: block;
                clear: both;
            }
            .header_box {
                padding-bottom: 8px;
                display: flex;
                > div {
                    padding: 2px 4px;
                    font-size: 12px;
                    line-height: 12px;
                    border: 1px solid #36b374;
                    color: #36b374;
                }

                > div:not(:last-child) {
                    margin-right: 8px;
                }
                .locationBage {
                    background: #fff;
                    color: #2283E6;
                    border: 1px solid #2283E6;
                }
            }
            .header_time {
                margin-bottom: 8px;
                .time_left {
                    font-size:14px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:14px;
                }
                .time_right {
                    font-size:14px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:18px;
                }
            }
            div:last-child{
                margin-bottom: 0px;
            }
        }
        .main_trust {
            padding: 20px 16px 19px;
            width: 100%;
            height: 100%;
            .trust_title {
                margin-bottom: 10px;
                display: flex;
                .title_left {
                    font-size:14px;
                    font-family:PingFangSC-Semibold,PingFang SC;
                    font-weight:600;
                    color:rgba(51,51,51,1);
                    line-height:14px;
                }
                .title_right {
                    font-size:20px;
                    font-family:DIN-Bold,DIN;
                    font-weight:bold;
                    color:rgba(54,179,116,1);
                    line-height:16px;
                    margin-left: 8px;
                }
            }
            .trust_count {
                display: flex;
                justify-content: space-between;
                .count_box {
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:12px;
                }
            }
            .trust_type {
                margin-top: 20px;
                .trust_type_line {
                    margin-bottom: 10px;
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:12px;
                    .line_right {
                        font-size:12px;
                        font-family:PingFangSC-Semibold,PingFang SC;
                        font-weight:600;
                        color:rgba(54,179,116,1);
                        line-height:12px;
                    }
                }
                div:last-child {
                    margin-bottom: 0px;
                }
            }
        }
        .main_score {
            padding: 20px 16px 19px;
            width: 100%;
            height: 152px;
            .score_title {
                margin-bottom: 10px;
                display: flex;
                .title_left {
                    font-size:14px;
                    font-family:PingFangSC-Semibold,PingFang SC;
                    font-weight:600;
                    color:rgba(51,51,51,1);
                    line-height:14px;
                }
                .title_right {
                    font-size:20px;
                    font-family:DIN-Bold,DIN;
                    font-weight:bold;
                    color:rgba(255,140,25,1);
                    line-height:16px;
                    margin-left: 8px;
                }
            }
            .score_count {
                display: flex;
                justify-content: space-between;
                .count_box {
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:12px;
                }
            }
            .score_type {
                margin-top: 20px;
                .score_type_line {
                    margin-bottom: 10px;
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:12px;
                    .line_right {
                        font-size:12px;
                        font-family:PingFangSC-Semibold,PingFang SC;
                        font-weight:600;
                        color:rgba(255,140,25,1);
                        line-height:12px;
                    }
                }
            }
        }
        .main_rating {
            padding: 20px 16px 19px;
            width: 100%;
            height: 75px;
            .rating_title {
                margin-bottom: 10px;
                display: flex;
                .title_left {
                    font-size:14px;
                    font-family:PingFangSC-Semibold,PingFang SC;
                    font-weight:600;
                    color:rgba(51,51,51,1);
                    line-height:14px;
                }
                .title_right {
                    font-size:20px;
                    font-family:DIN-Bold,DIN;
                    font-weight:bold;
                    color:rgba(54,179,116,1);
                    line-height:16px;
                    margin-left: 8px;
                }
            }
            .rating_count {
                display: flex;
                justify-content: space-between;
                .count_box {
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:12px;
                }
            }
        }
        .main_comInfo {
            padding: 19px 16px;
            .comInfo_title {
                font-size:14px;
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:rgba(51,51,51,1);
                line-height:14px;
                margin-bottom: 18px;
            }
            .comInfo_box {
                margin-bottom: 10px;
                .comInfo_box_left {
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:12px;
                }
                .comInfo_box_right {
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height:16px;
                }
            }
            > div:last-child {
                margin-bottom: 0px;
            }
        }
    }
}
</style>
